import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import errorToast from "../../../../helper-components/error-toast";

import LoadingSpinner from "../../../../helper-components/loading-spinner";
import { Field, Form, Formik } from "formik";

import AddButton from "../../../../buttons/button";
import DeleteIcon from "../../../../../assets/icons/delete-icon";

import successToast from "../../../../helper-components/success-toast";
import {
  countrySearchListAction,
  regionCreateAction,
  regionDeleteAction,
  regionEditAction,
  regionSearchListAction,
} from "../../../../../redux/actions/settings-action";
import SelectField from "../../../../forms/select-field";
import { mapListToOptions } from "../helper/helper-comp";

function RegionComp({ pageLoading, setPageLoading, searchValue ,setReload,reload }) {
  const [initialData, setItemTypeData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [dropList, setDropList] = useState([]);

  const tableHeading = [
    "Region Code",
    "Region Name",
    "Country Code/Name",
    "Actions",
  ];
  const initialValues = {
    data: initialData,
    newLine: {
      code: "",
      name: "",
      relation: "",
    },
  };
  const dispatch = useDispatch();

  const onSuccess = (data) => {
    setItemTypeData(data?.data?.list);
    setLoading(false);
    console.log("drugs loaded successfully", data.data);
  };

  const onSaveSuccess = (data) => {
    fetchData();
    setLoading(false);
    successToast(data?.message);
  };

  const onSaveError = (data) => {
    fetchData();
    setLoading(false);
    errorToast(data?.data?.message);
  };

  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };

  const fetchData = (searchValue = "") => {
    if (loading) {
      return;
    }

    setLoading(true);
    dispatch(regionSearchListAction(searchValue, onSuccess, onError));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 800);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedSearchValue !== "" || searchValue === "") {
      fetchData(debouncedSearchValue);
    }
  }, [debouncedSearchValue]);

  const onSubmit = (values) => {
    console.log("clicked");
    if (!loading) {
      const changedObjects = [];
      let newLineObject = null;

      initialData?.forEach((item, index) => {
        if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
          changedObjects.push(values.data[index]);
        } else return;
      });

      if (
        JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
      ) {
        if (
          values.newLine.code === "" ||
          values.newLine.name === "" ||
          values.newLine.relation === "" ||
          values.newLine.relation === undefined ||
          values.newLine.relation === null
        ) {
          errorToast("Region Code, Name and Country are required");
        } else newLineObject = values.newLine;
      }

      if (newLineObject !== null) {
        setLoading(true);
        console.log("create --", newLineObject);
        dispatch(regionCreateAction(newLineObject, onSaveSuccess, onSaveError));
      }

      if (changedObjects.length > 0) {
        setLoading(true);
        let cleanData = [...changedObjects];
        cleanData.forEach((item, _) => {
          delete item?.created_date;
          delete item?.update_date;
          delete item?.country_code;
          delete item?.country_name;
        });
        dispatch(regionEditAction(cleanData, onSaveSuccess, onSaveError));
      }
    }
  };

  const onClickDelete = (roleId) => {
    if (!loading) {
      setLoading(true);
      dispatch(regionDeleteAction({ id: roleId }, onSaveSuccess, onSaveError));
    }
  };
  //   const mapListToOptions = (data) => {
  //     return (
  //       data?.data?.list?.map((item) => ({
  //         label: item?.code + " " + item?.name, // e.g. "C001 Customer A"
  //         value: item?.id, // e.g. 123
  //       })) || []
  //     );
  //   };

  const onDropSuccess = (data) => {
    console.log("...", data?.data);
    setDropList(mapListToOptions(data));
  };

  const onDropError = (data) => {
    errorToast(data?.data?.message);
  };
  const fetchDropData = () => {
    if (loading) {
      return;
    }

    setLoading(true);
    dispatch(countrySearchListAction("", onDropSuccess, onDropError));
  };

  useEffect(() => {
    fetchDropData();
  }, []);
 useEffect(() => {
    if (reload) {
      fetchData();
      setReload(false);
    }
  }, [reload]);
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <Form className="pt-1">
          <div
            className="flex flex-col justify-between rounded-xl"
            style={{ height: "74vh" }}
          >
            {console.log("---", values)}
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading?.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {values?.data?.map((item, index) => (
                      <tr
                        className={` bg-[var(--list-table-row-bg)]
                         h-[50px] `}
                        key={index}
                      >
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <Field
                            name={`data[${index}].code`}
                            placeholder="Enter Code"
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <Field
                            name={`data[${index}].name`}
                            placeholder="Enter Name"
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          {/* <SelectField
                            // isDisabled={isDisabled}
                            containerClass="m-0 p-0"
                            placeholder="Select Country code/name"
                            options={dropList}
                            label=""
                            id={`data[${index}].relation`}
                            name={`data[${index}].relation`}
                            isSearchable={true}
                            errMsgContainerClass="hidden"
                            isRequired={true}
                            labelWidth="10rem"
                          /> */}
                          <SelectField
                            defaultValue={dropList.find(
                              (option) => option.value == item.relation
                            )}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            label=""
                            general_color="true"
                            borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                            isContainer={true}
                            containerClass={` w-full flex flex-col gap-2`}
                            parentClass={`w-[70%] flex flex-col gap-2`}
                            errMsgContainerClass="hidden"
                            placeholder="Select Country code/name"
                            options={dropList}
                            name={`data[${index}].relation`}
                            isSearchable={true}
                            isRequired={false}
                          />
                        </td>

                        <td className="tab-cell align-middle text-sm fw_400 text-secondary w-1/12 ">
                          <div className="flex items-center">
                            <button
                              type="button"
                              onClick={() => onClickDelete(item?.id)}
                            >
                              <DeleteIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                        <Field
                          name="newLine.code"
                          placeholder="Enter Code"
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                        <Field
                          name="newLine.name"
                          placeholder="Enter Name"
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                        <SelectField
                          defaultValue={dropList.find(
                            (option) => option.value == values.newLine.relation
                          )}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          label=""
                          general_color="true"
                          borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                          isContainer={true}
                          containerClass={` w-full flex flex-col gap-2`}
                          parentClass={`w-[70%] flex flex-col gap-2`}
                          errMsgContainerClass="hidden"
                          placeholder="Select Country code/name"
                          options={dropList}
                          name={`newLine.relation`}
                          isSearchable={true}
                          isRequired={false}
                        />
                      </td>

                      <td className="tab-cell text-sm fw_400 text-secondary w-1/12"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default RegionComp;
